module.exports = __webpack_public_path__ + "img/sidebar_serie_a_202627.787a93d8.png";